import getActions from "./actionsPopupUtils";

const agriculture_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default agriculture_actions;
